import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import IdvNonePage from './IdvNonePage';

const IdvNoneRoute: FuseRouteItemType = {
  path: '',
  element: <IdvNonePage />,
  auth: AUTH_ROLES.parent, // []
  children: [],
};

export default IdvNoneRoute;
